angular
    .module('app')
    .component('leadsList', {
        templateUrl: '/templates/pages/leads/leadsList/leadsList.html',
        controller: 'LeadsListController',
        controllerAs: 'vm',
    });